import { TStore } from '@/common/basis/types/tstore';

const state: TStore.Network = {
  isOnline: true,
};

export default state;
